<template>
  <MainLayout page-name="fees-for-weight-and-noise-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="preparation" @click="clickPreparation">料金マスタ準備</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
        @clear="clickClear"
        category="master"
      >
        <ChargeYear v-model="simpleSearchFormModel.charge_year" ref="childChargeYear" label="料金年度" prop="charge_year" :searchCond="true" :initialize="true" :required="true" tableType="WEIGHT_AND_NOISE" yearType = "reference" mode = "this" selectedIndex="0"/>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'landing_time', order: 'ascending' }"
      @row-click="clickRow"
      class="fees-for-weight-and-noise-master-table"
      :multi-select="false"
    >
      <template #columns>
        <RouteCodeColumn />
        <TextMiddleColumn label="ジェット区分" prop="jet_type_name" class-name="jet-type-name" />
        <TextMiddleColumn label="有償区分" prop="paid_type_name" />
        <FeeColumn label="適用最小重量" prop="min_weight" :formatter="formatterMin" />
        <FeeColumn label="適用最大重量" prop="max_weight" :formatter="formatterMax" />
        <DateTimeColumn label="更新日時" prop="updated_on" />
        <BlankColumn />
      </template>
    </Table>
    <FeesForWeightAndNoiseMasterPreparationDialog
      :visible.sync="preparationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForWeightAndNoiseRegisterMasterDialog
      :visible.sync="registerDialogVisible"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <FeesForWeightAndNoiseEditMasterDialog
      :visible.sync="editDialogVisible"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import TextMiddleColumn from '@/components/molecules/table/TextMiddleColumn.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'
import FeeColumn from '@/components/molecules/table/FeeColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import FeesForWeightAndNoiseMasterPreparationDialog from '@/components/pages/feeMaster/feesForWeightAndNoiseMaster/FeesForWeightAndNoiseMasterPreparationDialog.vue'
import FeesForWeightAndNoiseRegisterMasterDialog from '@/components/pages/feeMaster/feesForWeightAndNoiseMaster/FeesForWeightAndNoiseMasterRegisterDialog.vue'
import FeesForWeightAndNoiseEditMasterDialog from '@/components/pages/feeMaster/feesForWeightAndNoiseMaster/FeesForWeightAndNoiseMasterEditDialog.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    ChargeYear,
    SimpleSearch,
    Table,
    TextMiddleColumn,
    DateTimeColumn,
    RouteCodeColumn,
    FeeColumn,
    BlankColumn,
    FeesForWeightAndNoiseMasterPreparationDialog,
    FeesForWeightAndNoiseRegisterMasterDialog,
    FeesForWeightAndNoiseEditMasterDialog
  },
  mixins: [],
  data () {
    return {
      title: '着陸料金マスタ[重量・騒音]',
      tableData: [],
      simpleSearchFormModel: {
        charge_year: ''
      },
      currentRow: {},
      preparationDialogVisible: false,
      registerDialogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForWeightAndNoiseMasterSearchCond')
  },
  methods: {
    clickPreparation () {
      this.preparationDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickClear () {
      this.$set(this.simpleSearchFormModel, 'charge_year', this.$refs.childChargeYear.options[0].value)
    },
    clickSearch () {
      sessionStorage.setItem('feesForWeightAndNoiseMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForWeightAndNoiseMasterSearchCond'))
      this.$axios
        .get('/search-fees-for-weight-and-noise-master', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (chargeYear) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForWeightAndNoiseMasterSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'charge_year', chargeYear)
        sessionStorage.setItem('feesForWeightAndNoiseMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      } else {
        this.$set(this.simpleSearchFormModel, 'charge_year', searchCond.charge_year)
      }

      this.search()
    },
    async clickRow (row, table) {
      this.$loadingMask.on()
      this.currentRow = row
      await this.searchDetailTable(this.currentRow)
      this.editDialogVisible = true
      this.tableData = table
    },
    // 子テーブルのデータを取得するlambdaを呼び出す関数
    async searchDetailTable (currentRow) {
      const searchCond = JSON.parse(JSON.stringify(currentRow))
      await this.$axios
        .get('/search-fees-for-weight-and-noise-detail-master', { params: { charge_year: searchCond.charge_year, route_code: searchCond.route_code, jet_type: searchCond.jet_type, paid_type: searchCond.paid_type, row_number: searchCond.row_number } })
        .then((res) => {
          this.currentRow.weights = res.data.list.weights
          this.currentRow.noises = res.data.list.noises
          this.currentRow.remoteIslands = res.data.list.remoteIslands
          this.currentRow.routeDiscounts = res.data.list.routeDiscounts
          this.currentRow.weightDiscounts = res.data.list.weightDiscounts
          this.currentRow.types = res.data.list.types
          console.log(this.currentRow)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    formatterMin (row, column) {
      if (row.min_weight !== null) {
        return String(row.min_weight).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    },
    formatterMax (row, column) {
      if (row.max_weight !== null) {
        return String(row.max_weight).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.fees-for-weight-and-noise-master-table {
  ::v-deep .table-wrapper-inner {
    .el-table {
      table {
        th,
        td {
          &.jet-type-name {
            width: 12rem;
          }
        }
      }
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
